export enum BookMessageTypes {
  CREATE_QUOTATION = 'CREATE_QUOTATION',
  PIN_STATUS = 'PIN_STATUS',
  CREATE_TASK = 'create_task',
  SESSION_TIMEOUT = 'sessionTimeout'
}

export enum ParserMessageTypes {
  SEND_DATA = 'PARSER_EXTENSION_SEND_DATA',
  PIN_STATUS = 'PARSER_EXTENSION_PIN_STATUS'
}
